export const getOrderDetailsCardInfo = (selectedCounter: any, selectedModule: any) => {
  let response: any = {};

  //M10-12866
  if (selectedModule == 4) {
    response = {
      "Counter Name": selectedCounter?.counter_location?.counter_hdr_id?.counter_name || "-",
      "Counter Type": selectedCounter?.drph_lnk_type?.dr_ph_lnk_code || "-",

      "Mobile Number": selectedCounter?.mobile || "-",
      ...(selectedCounter?.drph_lnk_type?.dr_ph_lnk_code !== "INDPH-HS" &&
        { "Clinic Name": selectedCounter?.counter_location?.clinic_name }),
      ...(selectedCounter?.drph_lnk_type?.dr_ph_lnk_code == "INDPH-HS" &&
        { "Hosiptal Name": selectedCounter?.counter_location?.counter_hdr_id?.hospital_id?.Hospital_Name }),
    
      "Email ID": selectedCounter?.counter_location?.counter_hdr_id?.email || "-",
      "DL No": selectedCounter?.counter_location?.counter_hdr_id?.drug_license_number || "-",
      
      Location: selectedCounter?.counter_location?.location_name || "-",
      "GST No": selectedCounter?.counter_location?.counter_hdr_id?.gst_number || "-",
      
      ...((selectedCounter?.drph_lnk_type?.dr_ph_lnk_code !== "INDPH-PH" && selectedCounter?.drph_lnk_type?.dr_ph_lnk_code !== "INDPH-HS") && {
        "MCI Regn. No.": selectedCounter?.counter_location?.counter_hdr_id?.mci_register_number || "-",
        Speciality: selectedCounter?.counter_location?.counter_hdr_id?.speciality_id?.speciality_desc || "-",
      }),     
    };
  } else {
    response = {
      "Doctor Full Name": selectedCounter?.counter_location?.counter_hdr_id?.counter_name || "-",
      "Counter Type": selectedCounter?.drph_lnk_type?.dr_ph_lnk_code || "-",

      "Mobile Number": selectedCounter?.mobile || "-",
      "MCI Regn. No.": selectedCounter?.counter_location?.counter_hdr_id?.counter_name || "-",

      "Clinic Name": selectedCounter?.counter_location?.clinic_name || "-",
      "Email ID": selectedCounter?.counter_location?.counter_hdr_id?.email || "-",

      City: selectedCounter?.counter_location?.address || "-",
      Location: selectedCounter?.counter_location?.address || "-",

      Speciality: selectedCounter?.counter_location?.counter_hdr_id?.speciality_id?.speciality_desc || "-",
      // "Pin Code": selectedCounter?.counter_location?.pincode || "-",
      // "Cluster Name": selectedCounter?.counter_stockist_lnk?.[0]?.stockist_cluster?.clusterCode?.cluster_name || "-",
      "Medvol Stockist Code": selectedCounter?.counter_stockist_lnk?.[0]?.stockist_cluster?.stockistCompanyLnk?.stockist?.medvol_code || "-",
      Stockist: selectedCounter?.counter_stockist_lnk?.[0]?.stockist_cluster?.stockistCompanyLnk?.stockist?.firm_name || "-",
      // "Counter Tag":
      //   selectedCounter?.counter_field_force_id?.[0]?.cmp_countertag_id?.length
      //     ? selectedCounter.counter_field_force_id?.[0].cmp_countertag_id
      //       .map((tag: any) => tag?.cmp_countertag_name)
      //       .join(", ")
      //     : "-",
      "App MO": (() => {
        const item = selectedCounter?.counter_field_force_id?.[0];

        const hasAuto = item?.enabled_auto_manual_order !== undefined;
        const hasManual = item?.is_enabledmanualorder !== undefined;

        if (!hasAuto && !hasManual) return "-";

        return item?.enabled_auto_manual_order || item?.is_enabledmanualorder
          ? "Enabled"
          : "Disabled";
      })(),
    };
  }
  //M10-12866

  return response;
};

export const getDefaultStockistInfo = (selectedCounter: any) => {
  let response: Record<string, string> = {};

  selectedCounter?.counter_stockist_lnk?.forEach((item: any) => {
    const clusterName = item?.stockist_cluster?.clusterCode?.cluster_name;
    const clusterStockist = item?.stockist_cluster?.stockistCompanyLnk?.stockist?.owner_name;

    if (clusterName && clusterStockist) {
      response[clusterName] = clusterStockist;
    }
  });

  response = {
    ...response,
  };

  return response;
};

export const getOrderInvoiceCardInfo = (fuidData: any) => {
  let response: any = {};

  response = {
    "Entered on": fuidData?.invoice?.created_date
      ? `${new Date(fuidData?.invoice?.created_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(fuidData?.invoice?.created_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
      //M10-11126
    "Approved on": fuidData?.invoice?.approved_date
      ? `${new Date(fuidData?.invoice?.approved_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(fuidData?.invoice?.approved_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",//M10-11126

    "E-Invoice Applicable": fuidData?.invoice?.stockistInvoiceAttachment?.is_einv_applicable == true ? "Yes" : "No",
    "E-Invoice Category": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.einvoice_cat == "Upload IRN/BarCode along with Invoice" ? "Category 1" : (fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.einvoice_cat == "Upload E-Inv Aknowledgement Copy separately" ? "Category 2" : (fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.einvoice_cat == "Periodic Bulk Upload of E-Invoice" ? "Category 3" : "-")),
    "Entered by": fuidData?.invoice?.entered_by || "-",

    "Approved by": fuidData?.invoice?.approved_by || "-",
    "IR No.": fuidData?.invoice?.irn || "-",
  };

  return response;
};

export const getOrderInvoiceAcknowledgementInfo = (fuidData: any) => {
  let response: any = {};

  response = {
    "Acknowledged on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Verified on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.verified_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.verified_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}`
      : "-",
    Type: "Image / Screen",

    "Acknowledged by.": '-',

    // "Acknowledged by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,
    "Verified by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.verified_by_name,
  };

  return response;
};

export const getOrderInfoHomeScreenData = (orderDetailsFilteredData: any) => {
  let response: any = {};
  const orderDetailsFiltered = orderDetailsFilteredData?.[0];

  response = {
    // M10-12112
    // "Counter name": orderDetailsFiltered?.counterInfo?.counterLinkType === "INDPH-HS" ?
    //   orderDetailsFiltered?.novu_metadata?.hospitalName :
    //   orderDetailsFiltered?.counterInfo?.counter_name || "-",
    "Counter name":orderDetailsFiltered?.counterInfo?.counter_name,
    // M10-12112
    "Company name": orderDetailsFiltered?.company_name || "-",
    "Division name": orderDetailsFiltered?.division_name || "-",
    Location: `${orderDetailsFiltered?.latitude},${orderDetailsFiltered?.longitude}`,
    "Order Mode": orderDetailsFiltered?.orderModeDetails?.code,
    // Filled with cndn_remarks_short_name from the cndn_remarks master in OrderInfoHomeScreen.
    "Order Type": "-",
    "Counter code": orderDetailsFiltered?.counter_code,
    City: orderDetailsFiltered?.counterInfo.city_name,
    "Order Initiated date": orderDetailsFiltered?.created_date
      ? `${new Date(orderDetailsFiltered?.created_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(orderDetailsFiltered?.created_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Counter location": orderDetailsFiltered?.counterInfo?.location_name || "-",
    "Counter location code": orderDetailsFiltered?.counterInfo?.location_code || "-",
    // "Division name": orderDetailsFiltered?.division_name,
    "Clinic name": orderDetailsFiltered?.novu_metadata?.clinicName || "-",

    "Order Placed date": orderDetailsFiltered?.order_complete_date
      ? `${new Date(orderDetailsFiltered?.order_complete_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(orderDetailsFiltered?.order_complete_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Stockist name": orderDetailsFiltered?.stockist_name,
    "Order Value": String(Math.trunc(orderDetailsFiltered?.billed_price)),
    "Link Type": orderDetailsFiltered?.counterInfo?.counterLinkType,
    "Stockist code": orderDetailsFiltered?.company_stockist_code,
    "Ordered by": orderDetailsFiltered?.actor_name,
    "Cash Discount %": orderDetailsFiltered?.order_cash_discount_perc,
    ...(orderDetailsFiltered?.counterInfo?.counterLinkType === "INDPH-HS" && { "Hospital Name": orderDetailsFiltered?.novu_metadata?.hospitalName || " " }),
    ...(orderDetailsFiltered?.counterInfo?.counterLinkType === "DRAPH" && { "Pharmacy Name": orderDetailsFiltered?.counterInfo?.pharmacy_name || " " }),   // M10-13417
    "HQ Code": orderDetailsFiltered?.headquarter_code,
    "HQ Name": orderDetailsFiltered?.headquarter_name,
    "Module Type":
      orderDetailsFiltered?.module_code == 4
        ? "KAM"
        : orderDetailsFiltered?.module_code == 2
          ? "POB"
          : orderDetailsFiltered?.module_code == 3
            ? "PUC"
            : orderDetailsFiltered?.upload_type === "INST"
              ? "Medvol - Institutional"
              : orderDetailsFiltered?.upload_type === "NMV"
                ? "Non-Medvol"
                : "Medvol", //M10-12866
    "Counter Tag":
      orderDetailsFiltered?.novu_metadata?.counter_tags
        ?.map((tag: any) => tag?.cmp_countertag_name)
        ?.join(",") || "",
    //M10-13812
    "PO ID Number": orderDetailsFiltered?.poid_number,
    "PO Ref No": orderDetailsFiltered?.poid_ref_number,
    "PO Expiry Date": orderDetailsFiltered?.po_valid_date
      ? `${new Date(orderDetailsFiltered?.po_valid_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(orderDetailsFiltered?.po_valid_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    // "Stockist PO Number": orderDetailsFiltered?.stockist_po_number,
    ...(orderDetailsFiltered?.novu_metadata?.kam_type==='kam-rc' &&{ "RC Type": orderDetailsFiltered?.is_non_rc_order ? "Non-RC" : "RC"})
    //M10-13812
  };

  return response;
};

export const getInvoiceAcknowledgementFullInfo = (fuidData: any) => {
  let response: any = {};

  response = {
    "Uploaded by": fuidData?.invoice?.stockistInvoiceAttachment?.uploader_name,
    "Uploaded on": fuidData?.invoice?.stockistInvoiceAttachment?.updated_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.updated_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}`
      : "-",
    "Invoice No.": fuidData?.invoice?.invoice_number,
    "Invoice Date": fuidData?.invoice?.created_date
      ? `${new Date(fuidData?.invoice?.created_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}`
      : "-",
    "Acknowledged on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}, ${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_date).toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
      : "-",
    "Acknowledged by.": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,
    "Verified on": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.verified_date
      ? `${new Date(fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.verified_date).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      })}`
      : "-",
    "Verified by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.verified_by_name,
    Type: "Image / Screen",
    // "Acknowledged by": fuidData?.invoice?.stockistInvoiceAttachment?.einvoiceDtl?.einvoice_attachment?.uploaded_by_name,
  };

  return response;
};
